import React from 'react';
import CenterImage from './../CenterImage/CenterImage';

const FileUploadImage = () => (
  <CenterImage
    image={
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="165"
        height="102"
        viewBox="0 0 165 102"
      >
        <g fill="none" fillRule="evenodd">
          <path fill="#FFF" d="M7.284 2H138.57v91.496H7.284z" />
          <g fill="#365568">
            <path d="M84 42.688h42.5a1.5 1.5 0 0 1 0 3H84a1.5 1.5 0 0 1 0-3zM84 55.475h29.667a1.5 1.5 0 0 1 0 3H84a1.5 1.5 0 0 1 0-3z" />
          </g>
          <path
            fill="#DFEBEB"
            d="M102.333 6.65h35v44.175s-1.138-22.26-9.526-32.614C119.419 7.857 102.333 6.65 102.333 6.65z"
          />
          <path
            stroke="#365568"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="3"
            d="M142 52.206V6.656A4.658 4.658 0 0 0 137.342 2H6.658A4.648 4.648 0 0 0 2 6.648v83.696A4.656 4.656 0 0 0 6.675 95h99.4m19.258 0H142V75.079"
          />
          <g transform="translate(13.667 18.275)">
            <path
              fill="#7FBABA"
              d="M28.769 38.645c14.511 0 16.731 6.692 16.731 6.692s-2.22 7.98-18.437 7.656C10.847 52.67 13.283 51.4 10.826 51.4c-4.837 0 3.431-12.754 17.943-12.754z"
            />
            <path
              stroke="#365568"
              strokeLinecap="round"
              strokeWidth="3"
              d="M8.167 48.825s6.492-10.463 19.478-10.463c12.985 0 17.855 5.98 17.855 5.98"
            />
            <ellipse
              cx="31.5"
              cy="22.087"
              fill="#7FBABA"
              rx="8.75"
              ry="8.719"
            />
            <ellipse
              cx="27.417"
              cy="21.506"
              stroke="#365568"
              strokeWidth="3"
              rx="9"
              ry="8.963"
            />
            <path
              stroke="#365568"
              strokeLinecap="round"
              strokeWidth="3"
              d="M54.833 19.337v35.3c0 2.569-2.089 4.65-4.666 4.65h-45.5C2.089 59.288 0 57.206 0 54.638V4.65C0 2.082 2.09 0 4.667 0h45.5c2.577 0 4.666 2.082 4.666 4.65v3.306"
            />
          </g>
          <g transform="translate(121 67)">
            <path
              fill="#FFF"
              d="M15.053 7l1.158-4.667h13.894L31.263 7H44v28H2.316V7h12.737z"
            />
            <path
              stroke="#365568"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              d="M41.684 18.667v14H0v-28h12.737L13.895 0h13.894l1.158 4.667h12.737v4.666"
            />
            <ellipse cx="23.158" cy="21" fill="#7FBABA" rx="6.947" ry="7" />
            <ellipse
              cx="20.842"
              cy="18.667"
              stroke="#365568"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              rx="6.947"
              ry="7"
            />
            <path
              fill="#DFEBEB"
              d="M39.368 18.667V30.24H27.79c3.587.494 6.382-.969 8.388-4.389 2.005-3.42 3.07-5.815 3.191-7.184z"
            />
          </g>
        </g>
      </svg>
    }
  />
);

export default FileUploadImage;
